import React from "react";
import { Link } from "react-router-dom";
import { Receipt, ChevronRight } from "lucide-react";

// ---- The signed-off Arabic Terms ----
export const TERMS_VERSION = "1.1";
export const TERMS_LAST_UPDATE = "أكتوبر 2026";

export const TERMS_SECTIONS = [
  {
    title: "أولاً: إنشاء الحساب",
    items: [
      "يحق لأي شخص إنشاء حساب داخل التطبيق.",
      "تخضع جميع الحسابات الجديدة للمراجعة والاعتماد قبل تفعيلها.",
      "لا يمكن استخدام التطبيق أو الاستفادة من خدماته قبل تفعيل الحساب.",
      "يحق لإدارة التطبيق تعليق أو إيقاف أو حذف أي حساب مخالف لشروط الاستخدام أو يشكل خطراً على أمن واستقرار النظام.",
    ],
  },
  {
    title: "ثانياً: إدارة الحسابات",
    items: [
      "تخضع جميع الحسابات الجديدة للمراجعة والاعتماد قبل تفعيلها.",
      "لا يمكن استخدام التطبيق أو الاستفادة من خدماته إلا بعد تفعيل الحساب.",
      "يحتفظ التطبيق بحق تعليق أو إيقاف أو حذف أي حساب مخالف لشروط الاستخدام أو يهدد أمن واستقرار النظام.",
      "يمكن إعادة تعيين كلمة المرور عند الحاجة وفق الإجراءات المعتمدة داخل التطبيق.",
      "لا يجوز للمستخدم محاولة الحصول على صلاحيات أو امتيازات غير مصرح بها أو تجاوز القيود المفروضة على حسابه.",
      "يحتفظ التطبيق بحق اتخاذ الإجراءات المناسبة لضمان سلامة النظام وحماية بيانات المستخدمين.",
    ],
  },
  {
    title: "ثالثاً: خصوصية البيانات",
    items: [
      "جميع الفواتير والصور والمرفقات والبيانات المالية المدخلة في التطبيق تعتبر ملكاً لصاحب الحساب فقط.",
      "لا يمكن لأي مستخدم الاطلاع على بيانات مستخدم آخر.",
      "تلتزم إدارة التطبيق بالمحافظة على سرية البيانات وعدم مشاركتها أو بيعها أو الإفصاح عنها لأي طرف آخر إلا إذا تطلب ذلك نظام أو جهة مختصة وفق الأنظمة المعمول بها.",
      "يتم استخدام البيانات فقط لتقديم خدمات التطبيق وتحسين تجربة المستخدم.",
    ],
  },
  {
    title: "رابعاً: كلمات المرور وأمن الحساب",
    items: [
      "يتحمل المستخدم مسؤولية المحافظة على سرية بيانات الدخول الخاصة به.",
      "في حال فقدان كلمة المرور يمكن طلب إعادة تعيينها وفق الإجراءات المعتمدة.",
      "قد يتم إصدار كلمة مرور مؤقتة عند إعادة التعيين، ويلتزم المستخدم بتغييرها عند أول تسجيل دخول.",
      "لا يتحمل التطبيق أي مسؤولية عن الأضرار الناتجة عن مشاركة بيانات الدخول مع الآخرين.",
    ],
  },
  {
    title: "خامساً: استخدام التطبيق",
    intro: "يلتزم المستخدم بما يلي:",
    items: [
      "إدخال بيانات صحيحة ودقيقة.",
      "استخدام التطبيق للأغراض المشروعة فقط.",
      "عدم محاولة الوصول إلى حسابات أو بيانات الآخرين.",
      "عدم رفع أو تخزين أي محتوى مخالف للأنظمة أو الحقوق القانونية للغير.",
      "عدم استخدام التطبيق بطريقة قد تؤثر على أمن النظام أو استقراره.",
    ],
  },
  {
    title: "سادساً: إيقاف أو تعليق الحساب",
    intro: "يجوز تعليق أو إيقاف أي حساب في الحالات التالية:",
    items: [
      "مخالفة شروط الاستخدام.",
      "إساءة استخدام التطبيق.",
      "محاولة الوصول غير المصرح به إلى النظام.",
      "إدخال بيانات مضللة أو غير نظامية.",
      "أي نشاط قد يهدد أمن التطبيق أو المستخدمين.",
    ],
    outro: "وفي حال إيقاف الحساب، قد يتم تقييد الوصول إلى خدمات التطبيق حتى معالجة سبب الإيقاف.",
  },
  {
    title: "سابعاً: سياسة الاحتفاظ بالفواتير والبيانات",
    items: [
      "يحتفظ التطبيق بالفواتير والصور والمرفقات والبيانات المرتبطة بها طوال مدة بقاء الحساب، ولا يحذفها تلقائياً بسبب مرور الزمن.",
      "يتم تطبيق سياسة الاحتفاظ نفسها على جميع المستخدمين دون استثناء.",
      "تبقى البيانات متاحة لصاحب الحساب، ويمكنه استعراض الفواتير السابقة وتصديرها.",
      "لا يمكن لأي مستخدم الاطلاع على بيانات مستخدم آخر خلال فترة الاحتفاظ.",
    ],
  },
  {
    title: "ثامناً: الأرشفة والحذف",
    items: [
      "لا توجد مدة صلاحية زمنية للفواتير، ولا تُحذف الفواتير القديمة تلقائياً.",
      "يوفر التطبيق للمستخدم الخيارات التالية: تصدير الفواتير إلى PDF، تصدير الفواتير إلى Excel، أرشفة الفواتير، حذف الفواتير.",
      "تتم الأرشفة أو الحذف بناءً على إجراء صريح من المستخدم أو حذف الحساب وفق سياسة التطبيق.",
      "يُنصح المستخدم بالاحتفاظ بنسخة احتياطية من بياناته المهمة.",
    ],
  },
  {
    title: "تاسعاً: حدود المسؤولية",
    items: [
      "يسعى التطبيق إلى توفير أعلى درجات الأمان والاستقرار وحماية البيانات وفق الإمكانات التقنية المتاحة.",
      "لا يتحمل التطبيق مسؤولية فقدان البيانات الناتج عن: مشاركة بيانات الدخول مع الآخرين، أو استخدام غير صحيح للتطبيق، أو حذف المستخدم لبياناته بنفسه.",
      "يتحمل كل مستخدم مسؤولية صحة البيانات التي يقوم بإدخالها.",
    ],
  },
  {
    title: "عاشراً: التعديلات على الاتفاقية",
    items: [
      "يحق لإدارة التطبيق تعديل أو تحديث هذه الاتفاقية عند الحاجة، وتصبح التعديلات نافذة بمجرد نشرها داخل التطبيق أو إشعار المستخدم بها.",
    ],
  },
  {
    title: "الحادي عشر: الموافقة على الاتفاقية",
    items: [
      "يُعد إنشاء الحساب أو تسجيل الدخول أو استخدام التطبيق موافقة صريحة وكاملة على جميع الشروط والأحكام الواردة في هذه الاتفاقية.",
      "وفي حال عدم الموافقة على أي بند من بنودها، يجب التوقف عن استخدام التطبيق وعدم الاستمرار في التسجيل أو الاستخدام.",
    ],
  },
];

// Compact, scrollable rendering used both inside the register modal and the standalone page.
export function TermsBody({ compact = false }) {
  return (
    <div className={compact ? "space-y-5" : "space-y-7"} data-testid="terms-body">
      <header className={compact ? "" : "mb-6 pb-5 border-b border-[#1A1C19]/10"}>
        <div className="text-xs text-[#8A8D86] font-readex">آخر تحديث: {TERMS_LAST_UPDATE}</div>
        {!compact && (
          <h1 className="font-readex font-semibold text-3xl text-[#1A1C19] mt-2 leading-tight">
            اتفاقية الاستخدام وسياسة الخصوصية
          </h1>
        )}
        <p className="text-[#5C605A] mt-3 leading-relaxed text-sm">
          مرحباً بكم في تطبيق <span className="font-medium text-[#1A1C19]">فواتيري</span> لإدارة الفواتير.
          تهدف هذه الاتفاقية إلى توضيح حقوق والتزامات المستخدمين وآلية استخدام التطبيق وحماية البيانات.
          يُعدّ إنشاء حساب أو تسجيل الدخول أو استخدام التطبيق موافقةً كاملة على جميع البنود الواردة في هذه الاتفاقية.
        </p>
      </header>

      {TERMS_SECTIONS.map((sec, idx) => (
        <section key={idx} className="font-readex">
          <h3 className="font-medium text-[#1F3A33] mb-2 text-base">{sec.title}</h3>
          {sec.intro && <p className="text-[#5C605A] text-sm mb-2 leading-relaxed">{sec.intro}</p>}
          <ol className="space-y-1.5 list-decimal pe-5 text-sm text-[#1A1C19] leading-relaxed marker:text-[#6A8A76]">
            {sec.items.map((it, j) => (
              <li key={j}>{it}</li>
            ))}
          </ol>
          {sec.outro && <p className="text-[#5C605A] text-sm mt-2 leading-relaxed">{sec.outro}</p>}
        </section>
      ))}

      <footer className="mt-6 p-4 bg-[#F5F4EF] rounded-md border-r-4 border-[#6A8A76] text-sm text-[#1A1C19] leading-relaxed font-readex">
        أقرّ بأنني قرأت وفهمت ووافقت على اتفاقية الاستخدام وسياسة الخصوصية،
        وأتعهّد بالالتزام بجميع الشروط والأحكام الواردة فيها.
      </footer>
    </div>
  );
}

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#F5F4EF]" dir="rtl">
      <header className="bg-white border-b border-[#1A1C19]/10">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-[#1F3A33]">
            <div className="w-9 h-9 rounded-md bg-[#1F3A33] text-white flex items-center justify-center">
              <Receipt className="w-5 h-5" strokeWidth={1.5} />
            </div>
            <span className="font-readex font-semibold text-lg">فواتيري</span>
          </Link>
          <Link to="/" className="text-sm text-[#5C605A] hover:text-[#1A1C19] inline-flex items-center gap-1 font-readex">
            العودة <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-10" data-testid="terms-page">
        <div className="bg-white rounded-lg border border-[#1A1C19]/10 shadow-3d-sm p-8">
          <TermsBody />
        </div>
      </main>
    </div>
  );
}

